import { ref, computed, watch } from 'vue'

const STEP_STATUS = {
    Current: Symbol('current'),
    Complete: Symbol('complete'),
    Incomplete: Symbol('incomplete')
}

const _venueSteps = ref([
    {
        id: 0,
        title: 'Create a venue profile',
        desc: 'We match you with local artists based on your profile. It also helps artists to get to know you.',
        status: STEP_STATUS.Current,
        cta: 'Complete Your Profile'
    },
    {
        id: 1,
        title: 'Create your first event',
        desc: "Fill out important details like what kind of music you're looking for and set your budget. Share the event with anyone. As soon as you have an event posted, artists in Hedlyner can see and apply.",
        status: STEP_STATUS.Incomplete,
        cta: 'Create Event'
    },
    {
        id: 2,
        title: 'Find and book artists',
        desc: 'Find the best fit for your venue and negotiate rates for multiple events at the same time.',
        status: STEP_STATUS.Incomplete,
        cta: 'Manage Event'
    },
    {
        id: 3,
        title: 'Finish booking event',
        desc: "Once you've found the right artists for your show, close the event to new applications. If paying through Hedlyner, funds won't be released until after the show.",
        status: STEP_STATUS.Incomplete,
        cta: 'Finalize lineup'
    },
    {
        id: 4,
        title: 'Wrap up the show',
        desc: 'Once your event is over, share feedback about the artists. And see a copy of the payout receipt.',
        status: STEP_STATUS.Incomplete,
        cta: 'Review performers'
    }
])
const _artistSteps = ref([
    {
        id: 0,
        title: 'Create an artist profile',
        desc: 'We recommend venues based on your profile. It also helps them get to know you when booking events.',
        status: STEP_STATUS.Current,
        cta: 'Complete Your Profile'
    },
    {
        id: 1,
        title: 'Find opportunities',
        desc: 'When you apply to opportunities, venue administrator and promoters are notified and review your application. They can send you an offer, or book you instantaneously.',
        status: STEP_STATUS.Incomplete,
        cta: 'Explore Opportunities'
    },
    {
        id: 2,
        title: 'Get booked',
        desc: 'Accept offers or make counteroffers. Negotiate a rate that works for both you and the venue.',
        status: STEP_STATUS.Incomplete,
        cta: 'Review Offers'
    },
    {
        id: 3,
        title: 'Get paid on-time',
        desc: 'Your payout is deposited in your bank account after you perform. All payments made outside of Hedlyner will be handled by your contact at the venue.',
        status: STEP_STATUS.Incomplete,
        cta: 'Update Payment Information'
    },
    {
        id: 4,
        title: 'Wrap up the show',
        desc: 'Once your event is over, share feedback about the venue. And see a copy of the payout receipt.',
        status: STEP_STATUS.Incomplete,
        cta: 'Review venue'
    }
])
const stepStatus = ref(null)

export default function (getStartedInfo, role) {
    const getStartedSteps = computed(() => {
        switch (role.value) {
            case 'artist':
                return _artistSteps.value
            case 'venue':
                return _venueSteps.value
            default:
                return []
        }
    })

    watch(getStartedInfo, (getStartedInfo) => {
        if (typeof getStartedInfo.status === 'number') {
            stepStatus.value = getStartedInfo.status
        }
    })
    watch(stepStatus, (status) => {
        if (status !== null) {
            getStartedSteps.value.forEach((step, indx) => {
                if (indx === status && !getStartedInfo.value.disabled) {
                    step.status = STEP_STATUS.Current
                } else if (indx === status && getStartedInfo.value.disabled) {
                    step.status = STEP_STATUS.Complete
                } else if (indx > status) {
                    step.status = STEP_STATUS.Incomplete
                } else if (indx < status) {
                    step.status = STEP_STATUS.Complete
                }
            })
        }
    })
    return {
        STEP_STATUS,
        getStartedSteps,
        stepStatus
    }
}
